import React from "react";
import { Tooltip, Button } from "antd";
import {
  PaperClipOutlined,
  FilePdfOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import URL from "../../Main/url";

const DocumentCell = ({ documents }) => {
  if (!documents || documents.length === 0) {
    return <span className="text-gray-400">-</span>;
  }

  const getDocumentIcon = (document) => {
    const mimeType = document.mimetype || document.type;

    if (mimeType === "application/pdf" || document.type === "pdf") {
      return <FilePdfOutlined style={{ color: "#ff4d4f" }} />;
    } else if (mimeType?.startsWith("image/") || document.type === "image") {
      return <FileImageOutlined style={{ color: "#52c41a" }} />;
    } else {
      return <PaperClipOutlined style={{ color: "#1890ff" }} />;
    }
  };

  const getDocumentName = (document) => {
    return document.originalName || document.name || "Document";
  };

  const getFilePreviewUrl = (doc) => {
    if (doc.url) {
      return doc.url.startsWith("http") ? doc.url : `${URL}${doc.url}`;
    }
    return null;
  };

  const previewDocument = (doc) => {
    const previewUrl = getFilePreviewUrl(doc);
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  };

  return (
    <div className="flex justify-center gap-1 flex-wrap">
      {documents.map((doc, index) => (
        <div key={doc._id || index} className="flex flex-col items-center">
          <Tooltip title={`${getDocumentName(doc)} - Click to preview`}>
            <Button
              type="text"
              icon={getDocumentIcon(doc)}
              onClick={() => previewDocument(doc)}
              className="p-1 h-auto flex items-center justify-center"
              size="small"
            >
            </Button>
          </Tooltip>
          
        
        </div>
      ))}
    </div>
  );
};

export default DocumentCell;